import React from "react";
import { Autocomplete, TextField, Box, Avatar } from "@mui/material";

const CustomAutoComplete = ({
  id,
  options,
  value,
  label,
  formik = null, // Make formik optional
  getOptionLabel,
  isOptionEqualToValue,
  renderOption, // Optional custom render function
  onChange, // Optional custom onChange handler
  setNullOnClear = true, // Default behavior is to set the field to null on clear
  inputRef = null,
  nextRef = null,
  keyDown = null,
  isClinic = false,
  sx = {},
}) => {
  const handleChange = (event, newValue) => {
    if (onChange) {
      // If a custom onChange function is provided, use it
      onChange(event, newValue);
    } else if (formik) {
      // Default behavior: update the Formik field if formik is provided
      if (newValue === null && setNullOnClear) {
        formik.setFieldValue(id, null);
      } else {
        formik.setFieldValue(id, newValue);
      }
    }
  };

  const handleKeyDown = (event) => {
    if (keyDown) {
      keyDown(event);
    } else if (event.key === "Enter" && nextRef) {
      event.preventDefault(); // Prevent form submission
      if (nextRef.current) {
        nextRef.current.focus();
      }
    }
  };

  const renderClinicOption = (props, option) => (
    <Box component="li" sx={{ "& > img": { mr: 2, flexShrink: 0 } }} {...props}>
      <Avatar
        sx={{
          width: 32,
          height: 32,
          bgcolor: option.color,
          marginBottom: 0.5,
          marginRight: 1,
          border: 1,
          borderColor: "black",
        }}
      >
        {option.identificador}
      </Avatar>
      {option.razonsocial}
    </Box>
  );

  return (
    <Autocomplete
      id={id}
      options={options}
      value={value}
      size="small"
      sx={sx}
      autoHighlight
      onChange={handleChange} // Use the default or provided handleChange
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          onKeyDown={handleKeyDown}
          error={
            formik ? formik.touched[id] && Boolean(formik.errors[id]) : false
          }
          helperText={formik ? formik.touched[id] && formik.errors[id] : ""}
          FormHelperTextProps={{
            sx: { minHeight: "1.5em" }, // Reservar espacio para el helper text
          }}
          variant="outlined"
          inputProps={{
            ...params.inputProps,
            style: { justifyContent: "center" },
          }}
          inputRef={inputRef}
        />
      )}
      renderOption={isClinic ? renderClinicOption : renderOption} // Use custom render if provided
    />
  );
};

export default CustomAutoComplete;
